// D-0128 (Rafael 28/10): forma de pagamento "Apólice" na parcela.
// - Previsão: só escolher a forma, nada para anexar.
// - Efetivo: exige ao menos 1 apólice ligada à parcela; lista (nome, conferência, baixar), adicionar
//   outras e remover (com confirmação). Parcela paga/travada segue a regra do Remover NF.
// - Uma porta só (Rafael, 28/10): a apólice é uma nota do Documento Fiscal com tipo Apólice
//   (nota_fiscal.tipo = apolice), conferida pela I.A. O botão da parcela usa o mesmo envio
//   (vincularNFInterno com tipo_documento = apolice e a parcela marcada); a aba Documento Fiscal
//   com tipo Apólice conta para a parcela do mesmo jeito.
// Mesma regra da API (DadosPagamentoService + NotaFiscalParcelaService::previsoesComApolice +
// ApoliceParcelaPolicy.php); aqui só avisa e desabilita.

export const FORMA_APOLICE = 'apolice';

export const ehApolice = (forma) => String(forma || '') === FORMA_APOLICE;

export const PERFIS_REMOVER_APOLICE = [
    'evento', 'gerenteevento', 'gerenteeventointernacional',
    'financeiro', 'gerentefinanceiro', 'financeiro.adiantamento', 'financeiro.credito',
    'admin', 'diretor',
];

export const AVISO_SEM_PERMISSAO_APOLICE = 'Só Eventos e Financeiro (ou admin/diretor) removem a apólice.';

export const MSG_APOLICE_SEM_VINCULO = 'A apólice pode ser anexada depois que o Financeiro aprovar o plano.';

export const MSG_PREVISAO_APOLICE = 'Na Previsão basta escolher Apólice. A apólice é anexada no Efetivo, depois da aprovação do Financeiro.';

export const MSG_ULTIMA_APOLICE = 'Sem nenhuma apólice, o Efetivo desta parcela volta a exigir a apólice.';

const STATUS_INATIVOS = ['substituida', 'cancelada', 'rejeitada'];

export function podeRemoverApolice(perfil) {
    return PERFIS_REMOVER_APOLICE.includes(String(perfil || '').trim().toLowerCase());
}

// Apólices (notas do Documento Fiscal com tipo Apólice) que cobrem esta parcela da previsão.
// Nota antiga, sem vínculo por parcela, cobre o plano todo (regra da D-0099).
export const apolicesDaParcela = (forn, parcela) => {
    const pid = parcela && parcela.previsao_parcela_id ? String(parcela.previsao_parcela_id) : null;
    return ((forn && forn.nfs) || []).filter((nf) => nf && nf.apolice
        && !STATUS_INATIVOS.includes(String(nf.status || ''))
        && (!nf.por_parcela || (pid !== null && (nf.parcelas || []).map(String).includes(pid))));
};

// Pendências das parcelas com Apólice ("Parcela 01 (Apólice): falta a apólice anexada").
export const pendenciasApolice = (forn, parcelas, numero) =>
    (parcelas || []).reduce((acc, p, idx) => {
        if (!ehApolice(p.forma) || apolicesDaParcela(forn, p).length > 0) return acc;
        acc.push('Parcela ' + (numero ? numero(p, idx) : String(idx + 1)) + ' (Apólice): falta a apólice anexada');
        return acc;
    }, []);

// Selo do card do fornecedor: "Apólice registrada" (feminino), as outras siglas como antes.
export const seloTipoDocumento = (tipo) =>
    ehApolice(tipo) ? 'Apólice registrada' : String(tipo || '').toUpperCase() + ' registrado';
